<template>

  <!--提醒用户购买弹窗弹窗-->
  <div class="red-new-alert" @click="closeFun">
    <div class="red-new-alert-con border-box">
      <!--<div class="red-new-mid">亲！一次付费<br>畅听专辑<span style="color: #f14a01;">全部景点</span>解说哟~</div>-->
      <div class="red-new-mid" v-if="comeForm==1">一次付费<br>观看视频<span style="color: #f14a01;">后续精彩内容</span></div>
      <div class="red-new-mid" v-else="comeForm==2">一次付费<span style="color: #f14a01;" v-if="price">￥{{price}}</span><br>解锁收看该专辑<span style="color: #f14a01;">全部VR真人讲解</span></div>
      <div class="red-new-mid" v-else>解锁专辑<br>畅听<span style="color: #f14a01;">全部景点</span>解说!</div>
      <span class="red-new-line"></span>

      <div class="red-btn-box tc" v-if="buybtn">
        <div class="red-new-btn red-new-btn1" @click.stop="closeFun">取消</div>
        <div class="red-new-btn red-new-btn2" @click.stop="buybtn()">支付</div>
      </div>
      <div class="red-new-btn" @click.stop="closeFun" v-else>知道了</div>
      <div class="red-new-bg red-new-bg1"></div>
      <div class="red-new-bg red-new-bg2"></div>
    </div>
  </div>

</template>

<script>

  import {getCouponAtRandom} from '@/utils/wechat'
  import {setStore, getStore, removeStore} from '@/config/mUtils'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{

      }
    },
    created(){

    },
    props: ['comeForm','isDelete','buybtn','price'],
    computed: {

    },
    methods: {
      //关闭弹窗
      closeFun(){
        this.$emit('close', 0);
      }

    },
  }
</script>

<style scoped>

  /*一次性付费*/
  .red-new-alert{position:fixed;top:0;left:0;width: 100%;height:100%;background: rgba(0,0,0,.8);z-index: 999;}
  .red-new-alert-con{position:absolute;top:50%;left:50%;width: 85%;margin-left:-42.5%;padding:.76rem .5rem .53rem;background: #fff;border-radius: .16rem;transform: translateY(-50%);}
  .red-new-mid{position:relative;width: 100%;height:auto;text-align:center;line-height: .54rem;font-size: .38rem;color: #333;}
  .red-new-line{display: inline-block;width: 100%;height: 0;margin-top:.32rem;border-top: 1px dashed #e5e5e5;}
  .red-new-line{margin-top: .63rem;}
  .red-new-btn{width:2.79rem;height:.8rem;margin: .43rem auto 0;font:.28rem/.76rem "Microsoft YaHei";text-align: center;background: url(../assets/red-new-btnBg.png) no-repeat center;background-size: 100% 100%; }
  .red-btn-box .red-new-btn{ display: inline-block; width: 2rem; height: .78rem; font-size: .36rem; font-weight: bold; border: 1px solid #f8af3c; background-image: none; border-radius: .78rem; }
  .red-new-btn1{ margin-right: .17rem; color: #f8af3c; }
  .red-new-btn2{ margin-left: .17rem; background-color: #f8af3c; }
  .red-new-bg{position: absolute;background: rgba(255,255,255,.5);border-radius: 0 0 .16rem .16rem;}
  .red-new-bg1{left:.24rem;right:.24rem;bottom:-.23rem;height: .23rem;}
  .red-new-bg2{left:.65rem;right:.65rem;bottom:-.43rem;height: .2rem;}


</style>



// WEBPACK FOOTER //
// src/components/AlertPayTip.vue